// @ts-strict-ignore
import * as React from 'react';
import clsx from 'clsx';
import {Typography} from 'onboarding-components';

import {SvgIconReact} from 'common/components/svg-icon';
import {Trans} from 'common/i18n';
import {useTranslation} from 'common/i18n/hooks';

import {HelpTextType} from '../types';
import styles from './index.module.styl';

/* eslint-disable react/destructuring-assignment */
export const HelpText = ({
  type,
  children,
  animationTrigger,
}: {
  type?: HelpTextType;
  children?: React.ReactNode;
  animationTrigger?: {bounceInput: boolean};
}) => {
  const {t} = useTranslation();
  const {bounceInput} = animationTrigger;
  return (
    <div className={clsx(styles.helpTextContainer, {[styles.bounce]: bounceInput})}>
      <div className={clsx(styles.helpText, {[styles.show]: type === `edit-property`})}>
        <SvgIconReact icon='note' />
        <Typography variant='bodySm' className={styles.propertiesHelpText}>
          <Trans
            i18nKey={`onboarding.events.property-help-text`}
            t={t}
            components={{boldText: <span className={styles.bold} />}}
          />
        </Typography>
      </div>
      <div className={clsx(styles.helpText, {[styles.show]: type === `event`})}>
        {children}
        <Typography variant='bodySm'>
          <Trans
            i18nKey={`onboarding.events.event-help-text`}
            t={t}
            components={{boldText: <span className={styles.bold} />}}
          />
        </Typography>
      </div>
      <div className={clsx(styles.helpText, {[styles.show]: type === `select-property`})}>
        {children}
        <Typography variant='bodySm'>
          <Trans
            i18nKey={`onboarding.events.select-property-help-text`}
            t={t}
            components={{boldText: <span className={styles.bold} />}}
          />
        </Typography>
      </div>
    </div>
  );
};
